/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CreateByNameRequest} from "../model/create-by-name-request";
import {DeleteRatingItemIconSetRequest} from "../model/delete-rating-item-icon-set-request";
import {RatingItemIconSet} from "../model/rating-item-icon-set";

@Injectable({
    providedIn: "root",
})
export class SimRatingItemIconSetService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public createRatingItemIconSet(req: CreateByNameRequest) {
        return super.post<RatingItemIconSet>(`/api/RatingItemIconSet/CreateRatingItemIconSet`, req);
    }

    public deleteRatingItemIconSet(req: DeleteRatingItemIconSetRequest) {
        return super.post<void>(`/api/RatingItemIconSet/DeleteRatingItemIconSet`, req);
    }

    public getRatingItemIconSets() {
        return super.get<RatingItemIconSet[]>(`/api/RatingItemIconSet/GetRatingItemIconSets`, );
    }

    public saveRatingItemIconSet(ratingItemIconSet: RatingItemIconSet) {
        return super.post<RatingItemIconSet>(`/api/RatingItemIconSet/SaveRatingItemIconSet`, ratingItemIconSet);
    }
}